import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Clock, MapPin, AlertCircle } from 'lucide-react';

interface UpcomingTask {
  id: string;
  title: string;
  location: string;
  scheduledTime: string;
  priority: 'low' | 'medium' | 'high';
  estimatedDuration: string;
}

const upcomingTasks: UpcomingTask[] = [
  {
    id: '1',
    title: 'Plumbing Inspection',
    location: 'Building B, Unit 304',
    scheduledTime: '2024-01-21T10:00:00Z',
    priority: 'high',
    estimatedDuration: '1 hour',
  },
  {
    id: '2',
    title: 'Electrical Maintenance',
    location: 'Oak Residences',
    scheduledTime: '2024-01-21T13:00:00Z',
    priority: 'medium',
    estimatedDuration: '2 hours',
  },
  {
    id: '3',
    title: 'HVAC Filter Replacement',
    location: 'Pine View Complex',
    scheduledTime: '2024-01-21T15:00:00Z',
    priority: 'low',
    estimatedDuration: '45 minutes',
  },
];

export function UpcomingTasksCard() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Upcoming Tasks</CardTitle>
      </CardHeader>
      <CardContent>
        <ScrollArea className="h-[400px]">
          <div className="space-y-4">
            {upcomingTasks.map((task) => (
              <div
                key={task.id}
                className="flex items-start justify-between p-4 rounded-lg border"
              >
                <div className="space-y-2">
                  <div className="flex items-center gap-2">
                    <h3 className="font-medium">{task.title}</h3>
                    {task.priority === 'high' && (
                      <Badge variant="destructive" className="flex items-center gap-1">
                        <AlertCircle className="h-3 w-3" />
                        High Priority
                      </Badge>
                    )}
                  </div>
                  <div className="flex items-center gap-4 text-sm text-muted-foreground">
                    <div className="flex items-center gap-1">
                      <Clock className="h-4 w-4" />
                      <span>
                        {new Date(task.scheduledTime).toLocaleTimeString([], {
                          hour: '2-digit',
                          minute: '2-digit',
                        })}
                      </span>
                    </div>
                    <div className="flex items-center gap-1">
                      <MapPin className="h-4 w-4" />
                      <span>{task.location}</span>
                    </div>
                  </div>
                </div>
                <Badge variant="outline">
                  {task.estimatedDuration}
                </Badge>
              </div>
            ))}
          </div>
        </ScrollArea>
      </CardContent>
    </Card>
  );
}